export default __webpack_public_path__ + "static/media/ui-ux.1084fa9e.svg";